import { FC, useCallback } from "react";
import { map } from "lodash";

import { FlexContainer } from "shared/styles";
import {
  useSubscriptionContext,
  useBandSubscriptionContext,
} from "Bands/contexts";
import {
  BillingStatus,
  ISubscription,
  SubscriptionStatus,
  SubscriptionType,
  SubscriptionTypeWithTrial,
} from "Bands/types";
import { SubscriptionCard, SubscriptionCardType } from "Bands/components";

interface SubscriptionListProps {
  isLoading?: { [key in SubscriptionType]?: boolean };
  onSelect: (type: SubscriptionType) => void;
}

export const SubscriptionList: FC<SubscriptionListProps> = ({
  isLoading,
  onSelect,
}) => {
  const { subscriptions } = useSubscriptionContext();
  const { currentSubscription } = useBandSubscriptionContext();

  const getType = useCallback(
    (subscription: ISubscription) => {
      const {
        plan: currentPlan,
        billingStatus,
        nextPhasePlan,
        status: currentPlanStatus,
      } = currentSubscription || {};

      const { plan } = subscription;

      if (currentPlan === plan.toString()) {
        if (
          billingStatus === BillingStatus.not_automatically_renewed &&
          currentPlan !== SubscriptionTypeWithTrial.custom
        ) {
          return SubscriptionCardType.canceled;
        }

        if (currentPlanStatus === SubscriptionStatus.inactive) {
          return SubscriptionCardType.next;
        }

        return SubscriptionCardType.current;
      }

      if (nextPhasePlan === plan.toString()) {
        return SubscriptionCardType.next;
      }

      return SubscriptionCardType.default;
    },
    [currentSubscription]
  );

  return (
    <FlexContainer justifyContent="center" align="stretch">
      {map(subscriptions, (subscription) => (
        <SubscriptionCard
          key={subscription.plan}
          subscription={subscription}
          onSelect={onSelect}
          isLoading={isLoading?.[subscription.plan]}
          type={getType(subscription)}
        />
      ))}
    </FlexContainer>
  );
};
